import { common } from '@/locales/es-ES/common';
import { auth } from '@/locales/es-ES/auth';
import { navigation } from '@/locales/es-ES/navigation';
import { profile } from '@/locales/es-ES/profile';
import { workspace } from '@/locales/es-ES/workspace';
import { billing } from '@/locales/es-ES/billing';
import { work } from '@/locales/es-ES/work';
import { assets } from '@/locales/es-ES/assets';
import { inspections } from '@/locales/es-ES/inspections';
import { jobs } from '@/locales/es-ES/jobs';
import { lifecycleGate } from '@/locales/es-ES/lifecycleGate';
import { contacts } from '@/locales/es-ES/contacts';
import { copilot } from '@/locales/es-ES/copilot';
import { home } from '@/locales/es-ES/home';
import { assistant } from '@/locales/es-ES/assistant';
import { activity } from '@/locales/es-ES/activity';
import { schedule } from '@/locales/es-ES/schedule';
import { sites } from '@/locales/es-ES/sites';
import { timeline } from '@/locales/es-ES/timeline';
import { compliance } from '@/locales/es-ES/compliance';
import { guide } from '@/locales/es-ES/guide';
import { packs } from '@/locales/es-ES/packs';
import { notifications } from '@/locales/es-ES/notifications';
import { enUSResources } from '@/locales/en-US';
import { mergeLocaleResources } from '@/locales/mergeLocaleResources';

export const esESResources = mergeLocaleResources(enUSResources, {
  common,
  auth,
  navigation,
  profile,
  workspace,
  billing,
  work,
  assets,
  inspections,
  jobs,
  lifecycleGate,
  contacts,
  copilot,
  home,
  assistant,
  activity,
  schedule,
  sites,
  timeline,
  compliance,
  guide,
  packs,
  notifications,
} as const);
